import React from "react";
import message from "antd/lib/message";
import Button from "antd/lib/button";
import Row from "antd/lib/row";
import Table from "antd/lib/table";
import Modal from "antd/lib/modal";
import Tooltip from "antd/lib/tooltip";
import Popconfirm from "antd/lib/popconfirm";
import get from "lodash/fp/get";
import { gql, graphql, compose } from "react-apollo";
import { connect } from "react-redux";
import { gspActions } from "../../gspRedux";
import Get2AForm from "../GSP/Get2AForm";
import gspAuth from "../../services/GSPService";
import moment from "moment";
import toString from "lodash/fp/toString";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import notification from "antd/lib/notification";
import Icon from "antd/lib/icon";
import pick from "lodash/fp/pick";
import {
  CompanyByIdQuery,
  V2_PR_Summary_Query
} from "qgst-gql-queries/web/data.json";
import { Root, ContentWrapper as Content } from "../../shared/styles";
import DropZone from "react-dropzone";
import Purchase from "../../services/V2PurchaseService";
import Anx2Reconcile from "./Anx2Reconcile";
import { BASE_URL } from "../../shared/constants";
import filter from "lodash/fp/filter";
// import ANX2_PR_B2B from './ANX2_PR_B2B';
import ANX2B2B from "./ANX2B2B";
import ANX2DE from "./ANX2DE";
import ANX2SEZWP from "./ANX2SEZWP";
import ANX2SEZWOP from "./ANX2SEZWOP";
import Items from "../GSTN_Sync/Items";
import Col from "antd/lib/col";
import './Anx2Buttons.css';

var comp_id = "...";

const Anx2Register = props => {
  return (
    <Root>
      <Content>

      <Row
      gutter={[16, 16]} // Dynamic spacing
      // className="anx2_all_btn"
      style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', padding: '16px' }}
    >
      <Col xs={24} sm={12} md={8} lg={6} xl={4} className="anx2_1">
        <Button
          id="btn_1"
          size="large"
          icon="cloud-upload"
          className="anx2-btn"
          onClick={props.reconcile}
        >
          <div>
            <p>ANX2</p>
            <p style={{ color: '#298AB7' }}>Summary</p>
          </div>
        </Button>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4} className="anx2_1">
        <DropZone
          onDrop={props.onDropAnx2}
          multiple={false}
          disabled={props.role === 'reviewer'}
        >
          {({ getRootProps, getInputProps }) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <Button
                id="btn_2"
                size="large"
                icon="cloud-upload"
                className="anx2-btn"
                disabled={props.role === 'reviewer'}
              >
                <div>
                  <p>Upload</p>
                  <p style={{ color: '#298AB7' }}>Purchase Register</p>
                </div>
              </Button>
            </div>
          )}
        </DropZone>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4} className="anx2_1">
        <Button
          id="btn_3"
          size="large"
          icon="cloud-upload"
          className="anx2-btn"
          onClick={props.onAnx2}
          disabled={props.role === 'reviewer'}
        >
          Get ANX2
        </Button>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4} className="anx2_1">
        <Button
          id="btn_4"
          size="large"
          icon="cloud-upload"
          className="anx2-btn"
          onClick={props.reconcile}
        >
          Match Now
        </Button>
      </Col>

      <Col xs={24} sm={12} md={8} lg={6} xl={4} className="anx2_1">
        <Tooltip title="Clear all Purchases for selected Tax Period">
          <Popconfirm
            placement="bottomRight"
            onVisibleChange={props.popupConfirmResetVisibleChange}
            visible={props.popupConfirmReset}
            title="Clicking Yes will reset all Purchases for selected Tax Period!"
            onConfirm={props.resetPurchase}
            okText="Yes"
            cancelText="No"
          >
            <Button
              className="anx2-reset-btn"
              size="large"
              disabled={props.role === 'reviewer'}
            >
              <svg
                width="27"
                height="39"
                viewBox="0 0 23 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="reset-svg"
              >
                <path
                  d="M3.2619 10.5C3.2619 12.5449 3.92175 14.5353 5.14338 16.1752C6.365 17.8151 8.08318 19.0171 10.0425 19.6025C12.0019 20.1878 14.0979 20.1253 16.0189 19.4243C17.9399 18.7232 19.5834 17.421 20.7051 15.7111C21.8268 14.0013 22.3669 11.9752 22.245 9.93389C22.1232 7.89259 21.3459 5.9451 20.0287 4.38088C18.7115 2.81666 16.9248 1.71921 14.934 1.25165C12.9432 0.784095 10.8547 0.971388 8.97894 1.78569"
                  stroke="#595959"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
                <path
                  d="M1 12.7619L2.94181 10.4317C3.11859 10.2196 3.43388 10.1909 3.64602 10.3677L5.97619 12.3095"
                  stroke="#595959"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                />
              </svg>
              Reset
            </Button>
          </Popconfirm>
        </Tooltip>
      </Col>
    </Row>

        {props.summary && props.pageNumber === 1 && (
          <Row>
            <Table
              style={{ marginTop: "15px" }}
              bordered
              title={() => "Summary of Uploaded Purchases"}
              columns={props.summary.columns}
              dataSource={props.summary.data}
            ></Table>
          </Row>
        )}
        <Modal
          centered
          width={"90%"}
          visible={props.summary_modal_visible}
          onCancel={props.handleCancel}
          onOk={props.handleCancel}
        >
          {/* {props.summary_modal_source === "b2b" && <ANX2_PR_B2B />} */}
          {/* {props.summary_modal_source === "de" && <ANX2_PR_DE />} */}
          {props.summary_modal_source === "anx2-b2b" && <ANX2B2B />}
          {props.summary_modal_source === "anx2-de" && <ANX2DE />}
          {props.summary_modal_source === "anx2-sezwp" && <ANX2SEZWP />}
          {props.summary_modal_source === "anx2-sezwop" && <ANX2SEZWOP />}
        </Modal>
        {props.recon_summary && props.pageNumber === 1 && (
          <Row>
            <Table
              style={{ marginTop: "15px" }}
              bordered
              title={() => "Summary of Purchases from ANX2"}
              columns={props.recon_summary.columns}
              dataSource={props.recon_summary.data}
            ></Table>
          </Row>
        )}
        {props.summary && props.pageNumber === 4 && (
          <Row>
            <Anx2Reconcile {...props} recon_results={props.recon_results} />
          </Row>
        )}
      </Content>
    </Root>
  );
};

class Anx2DashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    var d = new Date();
    var n = d.getMonth();
    var y = d.getYear();
    var curyear = 1900 + y;
    var nextyear = curyear + 1 - 2000;
    var year = curyear + "-" + nextyear;

    if (props.gspDetails !== undefined && props.gspDetails !== null) {
      this.gsp = {
        access_token: props.gspDetails.gspToken,
        otp: props.gspDetails.otp,
        response: null,
        response_delete: null
      };
    } else {
      this.gsp = {};
    }

    message.config({
      maxCount: 1
    });

    this.state = {
      pull2A: false,
      finMonth: props.finMonth,
      finYear: props.finYear,
      pageNumber: 1,
      companyId: props.selectedCompany,
      popupConfirmReset: false,
      summary_columns: [
        {
          title: "TABLE",
          dataIndex: "type",
          key: "type"
        },
        {
          title: "Documents",
          dataIndex: "record_count",
          key: "record_count",
          render: (text, record) => (
            <span>
              <a
                href="javascript:void(0);"
                id={record.type}
                style={{ textDecoration: "underline", color: "blue" }}
                onClick={this.showModal}
              >
                {record.record_count}
              </a>
            </span>
          )
        },
        {
          title: "Total Tax",
          dataIndex: "total_tax",
          key: "total_tax"
        },
        {
          title: "IGST",
          dataIndex: "igst",
          key: "igst"
        },
        {
          title: "CGST",
          dataIndex: "cgst",
          key: "cgst"
        },
        {
          title: "SGST",
          dataIndex: "sgst",
          key: "sgst"
        },
        {
          title: "CESS",
          dataIndex: "cess",
          key: "cess"
        }
      ],
      summary_modal_source: null,
      summary_modal_visible: false
    };
    comp_id = props.selectedCompany;
  }

  popupConfirmResetVisibleChange = e => {
    if (!e) {
      this.setState({ popupConfirmReset: false });
      return;
    }
    if (this.props.company) {
      if (this.props.company.role === "admin") {
        this.setState({ popupConfirmReset: true });
      } else {
        this.setState({ popupConfirmReset: false });
      }
    }
  };

  resetPurchase = () => {
    var downloaddate = this.props.finMonth + "/" + this.props.finYear;
    fetch(
      `${BASE_URL}/export/V2_ResetPurchase?companyId=${this.props.selectedCompany}&downloaddate=${downloaddate}`,
      {
        method: "GET"
      }
    ).then(result => {
      console.log(result);
      this.props.summary_refetch();
      message.success("All Purchases been reset for selected tax period");
    });
  };

  componentDidUpdate = () => {
    if (this.props.gspDetails !== undefined && this.props.gspDetails !== null) {
      this.gsp.access_token = this.props.gspDetails.gspToken;
      this.gsp.otp =
        this.gsp.otp !== undefined && this.gsp.otp !== null
          ? this.gsp.otp
          : this.props.gspDetails.otp;
    }
  };

  showModal = e => {
    console.log(e.target.id.toLowerCase());
    this.setState({
      summary_modal_source: e.target.id.toLowerCase(),
      summary_modal_visible: true
    });
  };

  handleCancel = e => {
    this.setState({
      summary_modal_visible: false
    });
  };
  reconcile = e => {
    const page_number = parseInt(e.target.id.split("_")[1]);
    if (page_number === 4) {
      message.loading("Matching records.. please wait!!", 0);
      var downloaddate = this.props.finMonth + "/" + this.props.finYear;
      fetch(
        `${BASE_URL}/export/reconcile?companyId=${this.props.selectedCompany}&downloaddate=${downloaddate}`,
        {
          method: "GET"
        }
      )
        .then(res => res.json())
        .then(async result => {
          const recon_results = [
            {
              key: 0,
              type: "Matched Invoices",
              results: result.match,
              count: result.match ? result.match.length : 0
            },
            {
              key: 1,
              type: "MisMatched Invoices",
              results: result.mismatch,
              count: result.mismatch ? result.mismatch.length : 0
            },
            {
              key: 2,
              type: "Only In Purchase Register",
              results: result.onlyInPR,
              count: result.onlyInPR ? result.onlyInPR.length : 0
            },
            {
              key: 3,
              type: "Only In Anx2",
              results: result.onlyInRecon,
              count: result.onlyInRecon ? result.onlyInRecon.length : 0
            },
            {
              key: 4,
              type: "Likely Matches",
              results: result.likely,
              count: result.likely ? result.likely.length : 0
            }
          ];
          this.setState({
            pageNumber: page_number,
            recon_results: recon_results
          });
          message.destroy();
        });
    } else {
      this.setState({ pageNumber: page_number });
    }
  };

  onDropAnx2 = async acceptedFiles => {
    var el = document.body,
      elChild = document.createElement("div");
    elChild.className = "root_div";
    elChild.innerHTML = '<div class="custom_loading loader"></div>';
    el.insertBefore(elChild, el.firstChild);
    document.getElementById("root").classList.add("blur");
    const result = await Purchase.upload({
      file: acceptedFiles[0],
      type: "pranx2",
      companyId: this.props.selectedCompany,
      finMonth: this.state.finMonth,
      finYear: this.state.finYear
    });
    document.body.getElementsByClassName("root_div")[0].remove(); // Get the <ul> element with id="myList"
    document.getElementById("root").classList.remove("blur");
    this.props.summary_refetch();

    // if ((result.error_status !== '') && (result.error_status !== undefined)) {
    //     //document.getElementById('sales_error_status').click();
    //     console.log('-----------------ERROR REPORT----------------');
    //     console.log(result.error_status);
    //     console.log('---------------------------------------------');
    // }
    // if (result.filestatus === true) {
    //     if (result.flag === true) {
    //         var dialogue_msg = '<div style="width: 20%; float:left"><img src="https://media.giphy.com/media/mh0zdNnHBV7z2/giphy.gif"/ style="width:90%;border: solid 1px #d0d0d0;border-radius: 25px 0px 25px 0px;"></div ><div style="width: 80%;"><br><p><h4> ( <span><b style="font-size: 12px;color: #0cde26;">' + result.total_errors + ' Invoices Failed out of ' + result.total + ' Invoices</b></span>) Anx1 Sales Register partially saved!</h4></p><br><p>Error Excel will be downloaded. Please check and correct the Errors!</p></div>';
    //         var div = document.getElementById('dialogue_append1');
    //         if (document.getElementById('dialogue_append1') !== null) {
    //             div.innerHTML += dialogue_msg;
    //         }
    //     }
    //     /************************************************************************************/
    //     if (result.total_errors > 0) {
    //         //message.error('(' + total_negative + '/' + result.total + ') Purchase data upload Failed!')
    //     }
    //     else {
    //         message.success('(' + result.total + '/' + result.total + ') Sales Invoices uploaded successfully!', 8)
    //     }
    //     // this.props.data.refetch()
    //     // this.props.gstr1summary.refetch()
    // } else if (result.file === false) {
    //     message.error('Uploaded file is not in Tally Excel format!', 5)
    // } else {
    //     message.error('Upload File Type is Not Allowed', 10)
    // }
  };

  otherGSTNInformation = companyDetails => {
    const state_cd = companyDetails["gstin"].substr(0, 2);
    companyDetails["state"] = state_cd;
    return companyDetails;
  };

  save2AFormRef = formRef => {
    this.form2ARef = formRef;
  };

  onAnx2 = () => {
    this.setState({ pull2A: true });
  };

  handleGet2ACancel = () => {
    this.setState({ pull2A: false });
  };

  handleGet2ASubmit = () => {
    const form = this.form2ARef.props.form;
    form.validateFields(async (err, fieldsValue) => {
      if (err) {
        return;
      }
      form.resetFields();

      const fromDate = fieldsValue["from_month"].format("MMYYYY");
      const toDate = fieldsValue["to_month"].format("MMYYYY");
      this.setState({ pull2A: false, call2A: true });
      message.loading("Getting records... please wait!!", 0);
      const data = this.getCounterPartyData(fromDate, toDate);
    });
  };

  periodArrayValues = (a, b) => {
    var dateStart = moment(a, "MMYYYY");
    var dateEnd = moment(b, "MMYYYY");
    // console.log("dateStart :" + dateStart + "---" + "dateEnd :" + dateEnd);
    var period = [];

    while (
      dateEnd > dateStart ||
      dateStart.format("M") === dateEnd.format("M")
    ) {
      period.push(dateStart.format("MMYYYY"));
      dateStart.add(1, "month");
    }
    return period;
  };

  getCounterPartyData = async (fromPeriod, toPeriod) => {
    var year_trim = this.props.finYear.split("-");
    var fy = "";
    if (this.props.finMonth < 4) {
      fy = "20" + year_trim[1];
    } else {
      fy = year_trim[0];
    }

    var period = toString(this.props.finMonth).padStart(2, "0") + "" + fy;

    const companyDetails = flow(
      pick(["gstin", "id", "gstnUserName"]),
      this.otherGSTNInformation
    )(this.props.company);

    const periodArrayValuesfor2A = this.periodArrayValues(fromPeriod, toPeriod);

    // console.log(periodArrayValuesfor2A);

    const reqData = {
      companyDetails: companyDetails,
      gspDetails: {
        gspToken: this.gsp.access_token,
        otp: this.gsp.otp
      },
      period: period
    };

    console.log(reqData);

    this.gsp.response = await gspAuth.generateLedgerBAL(reqData);

    console.log(this.gsp.response);

    // message.destroy();

    if (!this.gsp.response.data.success || !this.gsp.response.success) {
      if (
        this.gsp.response.data.errorCode &&
        this.gsp.response.data.errorCode.toUpperCase() === "RETOTPREQUEST"
      ) {
        message.destroy();
        this.setState({
          requestOTP: true,
          fromPeriod: fromPeriod,
          toPeriod: toPeriod,
          fromPullData: true,
          fromReconcile: null
        });
      }
    }

    if (this.gsp.response.data.success || this.gsp.response.success) {
      // console.log('Done Ledger');
      const gstr2A_B2B_Loop_Action = map(async d => {
        // console.log(d);
        const reqData = {
          companyDetails: companyDetails,
          gspDetails: {
            gspToken: this.gsp.response.gspAuth.access_token,
            otp: this.gsp.otp
          },
          toPeriod: toPeriod,
          period: d
        };
        this.gsp.response = await gspAuth.getCounterPartyData(
          reqData,
          "B2B",
          2
        );

        if (this.gsp.response.status === true) {
          message.destroy();
          this.props.summary_refetch();

          notification.open({
            message: "Success",
            description: "ANX2 fetched successfully!!",
            duration: 100,
            icon: <Icon type="check-circle" style={{ color: "#008000" }} />
          });
        }
      })(periodArrayValuesfor2A);
    }
  };

  render() {
    // console.log(this.props);
    return (
      <span>
        <Anx2Register
          onDropAnx2={this.onDropAnx2}
          onAnx2={this.onAnx2}
          companyId={this.props.selectedCompany}
          finMonth={this.props.finMonth}
          finYear={this.props.finYear}
          handleCancel={this.handleCancel}
          pageNumber={this.state.pageNumber}
          reconcile={this.reconcile}
          recon_results={this.state.recon_results}
          summary={{
            data: this.props.summary,
            columns: this.state.summary_columns
          }}
          recon_summary={{
            data: this.props.recon_summary,
            columns: this.state.summary_columns
          }}
          summary_modal_visible={this.state.summary_modal_visible}
          summary_modal_source={this.state.summary_modal_source}
          popupConfirmResetVisibleChange={this.popupConfirmResetVisibleChange}
          popupConfirmReset={this.state.popupConfirmReset}
          resetPurchase={this.resetPurchase}
        />
        <Get2AForm
          wrappedComponentRef={this.save2AFormRef}
          visible={this.state.pull2A}
          onSubmit={this.handleGet2ASubmit}
          onCancel={this.handleGet2ACancel}
        />
      </span>
    );
  }
}

const prSummaryConfig = {
  name: "summary",
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finyear: props.finYear,
      finmonth: props.finMonth + ""
    }
  }),
  props: ({ summary }) => {
    return {
      summary: get("viewer.v2_pr_summary.edges", summary),
      recon_summary: get("viewer.v2_recon_pr_summary.edges", summary),
      summary_refetch: get("refetch", summary)
    };
  }
};

const companyQueryConfig = {
  name: "company",
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finYear: props.finYear,
      finMonth: props.finMonth
    }
  }),
  props: ({ company }) => {
    return {
      company: get("viewer.company", company),
      gspDetails: get("viewer.gspInfo", company),
      externalInterfaceInfo: get("viewer.externalInterfaceInfo", company)
    };
  }
};

const mapStateToProps = state => {
  return {
    selectedCompany: state.local.selectedCompany,
    finMonth: state.local.finMonth,
    finYear: state.local.finYear,
    gspDetails: state.gsp
  };
};

export default compose(
  connect(mapStateToProps, {
    setGspToken: gspActions.setGspToken,
    setGspOtp: gspActions.setGspOtp,
    setGspDetails: gspActions.setGspDetails
  }),
  graphql(gql(V2_PR_Summary_Query), prSummaryConfig),
  graphql(gql(CompanyByIdQuery), companyQueryConfig)
)(Anx2DashboardContainer);
